import {ValidationForm} from "../../src/web/validation_form";
import Contact from "./catalogs/contact";

var CatalogStarterContact = {
    init() {
        this.saveAddress()
    },
    isValidStarterCatalogContact() {
        const ValidateForm = new ValidationForm()

        const isInputValid = ValidateForm.handleValidateInputForm($('.required'))
        const isInputValid2 = ValidateForm.handleValidateInputForm2($('.required2'))
        const isInputSelectValid = ValidateForm.handleValidateInputSelectForm($('.required-select'))
        const isValidPhone = ValidateForm.handleValidatePhone()
        const isValidEmail = ValidateForm.handleValidateEmail()
        const isValidZip = ValidateForm.handleValidateZipcode()
        const isValidFurigana = ValidateForm.handleValidateFurigana()
        const acceptPolicy = ValidateForm.handleValidateAcceptPolicy()
        const isInputAddressValid = ValidateForm.handleValidateAddressesForm($('#catalog_contact_prefecture'), $('#catalog_contact_city'), $('#catalog_contact_street_address'), $('.temporary-address-catalog-contact'))

        const isActive = isInputValid && isInputValid2 && isInputSelectValid && acceptPolicy && isValidEmail && isInputAddressValid
                            && isValidZip && isValidPhone && isValidFurigana

        return isActive
    },
    setAttributesContact (btnID, contactKey) {
        $(btnID).on('click', function (e) {
            let contact = {
                catalog_contact: {
                    last_name: $('#catalog_contact_last_name').val(),
                    first_name: $('#catalog_contact_first_name').val(),
                    last_name_kana: $('#catalog_contact_last_name_kana').val(),
                    first_name_kana: $('#catalog_contact_first_name_kana').val(),
                    zipcode: $('#catalog_contact_zipcode').val(),
                    prefecture: $('#catalog_contact_prefecture').val(),
                    city: $('#catalog_contact_city').val(),
                    street_address: $('#catalog_contact_street_address').val(),
                    building: $('#catalog_contact_building').val(),
                    tel: $('#catalog_contact_tel').val(),
                    mobile_tel: $('#catalog_contact_mobile_tel').val(),
                    email: $('#catalog_contact_email').val(),
                    receive_mail_flag: $('#catalog_contact_receive_mail_flag').val(),
                    special_notice: $('#catalog_contact_special_notice').val(),
                    accept_privacy: $('#catalog_contact_accept_privacy').is(':checked'),
                    plan_construction_site: $('#catalog_contact_plan_construction_site').val(),
                    plan_construction_city: $('#catalog_contact_plan_construction_city').val(),
                }
            }

            localStorage.setItem(contactKey, JSON.stringify(contact))
        })
    },
    fillContactFields (contactKey) {
        let contactFieldsJson = localStorage.getItem(contactKey)
        let contactFields = JSON.parse(contactFieldsJson)
        let currentUrl = window.location.href

        if (contactKey === 'starter_contact' && !currentUrl.includes('starter')) {
            return
        }

        if (contactKey === 'catalog_contact' && !currentUrl.includes('catalog')) {
            return
        }

        if (contactFields) {
            contactFields = contactFields.catalog_contact
            if ($('#catalog_contact_last_name').val()?.length === 0) {
                $('#catalog_contact_last_name').val(contactFields.last_name)
            }

            if ($('#catalog_contact_first_name').val()?.length === 0) {
                $('#catalog_contact_first_name').val(contactFields.first_name)
            }

            if ($('#catalog_contact_last_name_kana').val()?.length === 0) {
                $('#catalog_contact_last_name_kana').val(contactFields.last_name_kana)
            }

            if ($('#catalog_contact_first_name_kana').val()?.length === 0) {
                $('#catalog_contact_first_name_kana').val(contactFields.first_name_kana)
            }

            if ($('#catalog_contact_zipcode').val()?.length === 0) {
                $('#catalog_contact_zipcode').val(contactFields.zipcode)
            }

            if ($('#catalog_contact_prefecture').val()?.length === 0) {
                $('#catalog_contact_prefecture').val(contactFields.prefecture)
            }

            if ($('#catalog_contact_city').val()?.length === 0) {
                $('#catalog_contact_city').val(contactFields.city)
            }

            if ($('#catalog_contact_street_address').val()?.length === 0) {
                $('#catalog_contact_street_address').val(contactFields.street_address)
            }

            if ($('#catalog_contact_building').val()?.length === 0) {
                $('#catalog_contact_building').val(contactFields.building)
            }
            if ($('#catalog_contact_tel').val()?.length === 0) {
                $('#catalog_contact_tel').val(contactFields.tel)
            }
            if ($('#catalog_contact_mobile_tel').val()?.length === 0) {
                $('#catalog_contact_mobile_tel').val(contactFields.mobile_tel)
            }
            if ($('#catalog_contact_email').val()?.length === 0) {
                $('#catalog_contact_email').val(contactFields.email)
            }

            if (contactFields.receive_mail_flag?.length !== 0) {
                $('#catalog_contact_receive_mail_flag').val(contactFields.receive_mail_flag)
            }

            if ($('#catalog_contact_special_notice').val()?.length === 0) {
                $('#catalog_contact_special_notice').val(contactFields.special_notice)
            }
            if ($('#catalog_contact_plan_construction_site').val()?.length === 0) {
                const default_site = contactFields.plan_construction_site || '大分県'
                $('#catalog_contact_plan_construction_site').val(default_site)
            }
            if ($('#catalog_contact_plan_construction_city').val()?.length === 0) {
                $('#catalog_contact_plan_construction_city').val(contactFields.plan_construction_city)
            }
            if (contactFields.accept_privacy) {
                $('#catalog_contact_accept_privacy').prop('checked', true)
            }
        } else {
            if ($('#catalog_contact_plan_construction_site').val()?.length === 0) {
                $('#catalog_contact_plan_construction_site').val('大分県')
            }
        }
    },
    saveAddress () {
        const ValidateForm = new ValidationForm()
        ValidateForm.saveAddressesForm($('.temporary-address-catalog-contact'), $('#catalog_contact_prefecture'), $('#catalog_contact_city'), $('#catalog_contact_street_address'))
    }
}

export default CatalogStarterContact
